import outputs from './outputs'
import historic from './historic'

export default {
    outputs,
    historic,
}
